export const Sun = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2451_106824)">
      <path
        d="M10 2.74252V1.47314M4.86809 15.1323L3.9705 16.0299M10 18.5274V17.258M16.0293 3.97073L15.1318 4.86832M17.2574 10.0003H18.5268M15.1318 15.1323L16.0293 16.0299M1.4729 10.0003H2.74228M3.97044 3.97068L4.86802 4.86827M13.0935 6.90667C14.8021 8.61521 14.8021 11.3853 13.0935 13.0939C11.385 14.8024 8.61487 14.8024 6.90633 13.0939C5.19778 11.3853 5.19778 8.61521 6.90633 6.90667C8.61487 5.19813 11.385 5.19813 13.0935 6.90667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2451_106824">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default Sun
